'use client';

import StoreContainer from './_components';

export default function StorePage() {
  return <StoreContainer />;
}
